import { ref, onMounted } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import Header from '@/views/layout/header.vue';
import Player from './player/index.vue';
// import Player from './player/index.test.vue'
import ChatList from './chatList/index.vue';
import ChatBox from './chatBox/index.vue';
import ConnectTimeout from '@/views/common/connectTimeout.vue';
import roleHooks from '@/hooks/roleV2Hooks';
import bus from '@/utils/mitt.js';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      initAllRoleList,
      setIsShowLeft
    } = roleHooks();
    const player = ref(null);
    const chatbox = ref(null);
    const chatlist = ref(null);
    const isConnectError = ref(false);
    const errorType = ref();
    onMounted(() => {
      initAllRoleList();
    });
    const connectError = e => {
      isConnectError.value = true;
      errorType.value = e;
      bus.emit('flvEnd', true);
    };
    const getAudioStream = blob => {
      player.value.audioBlob(blob);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "chat_container",
        onClick: _cache[0] || (_cache[0] = $event => _unref(setIsShowLeft)(false))
      }, [_createVNode(Header), _createVNode(Player, {
        ref_key: "player",
        ref: player,
        onConnectError: connectError
      }, null, 512), _createVNode(ChatList, {
        ref_key: "chatlist",
        ref: chatlist
      }, null, 512), _createVNode(ChatBox, {
        ref_key: "chatbox",
        ref: chatbox,
        onUploadAudioStream: getAudioStream
      }, null, 512)]), _unref(isConnectError) ? (_openBlock(), _createBlock(ConnectTimeout, {
        key: 0,
        errorType: _unref(errorType),
        onChangeStatus: _cache[1] || (_cache[1] = $event => isConnectError.value = false)
      }, null, 8, ["errorType"])) : _createCommentVNode("", true)], 64);
    };
  }
});